import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import InstitutionProprietorTaxSelfCertificationForm from '@/features/institution/proprietor-tax-self-certification/components/form';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingProprietorTaxSelfCertificationPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="proprietorTaxSelfCertification" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionProprietorTaxSelfCertificationForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingProprietorTaxSelfCertificationPage.displayName = 'InstitutionOnboardingProprietorTaxSelfCertificationPage';

export default InstitutionOnboardingProprietorTaxSelfCertificationPage;
